enum FeatureFlags {
  CART_HAMS_CCP_OPEN_QUOTE_MIGRATION = 'cart-hams-ccp-open-quote-migration',
  CART_MAC_FUNCTIONALITY_MIGRATION = 'cart-mac-functionality-migration',
  CART_RENAME_ATLASSIAN_ACCESS_TO_GUARD = 'cart-rename-atlassian-access-to-guard',
  CART_MAC_MIGRATION_ENABLE_CCP_SEARCH_CALL = 'cart-mac-migration-enable-ccp-search-call',
  MIGRATION_CLOUDS_BANNER_FOR_PARTNERS = 'migration_clouds_baner_for_partners',
  CART_MAINTENANCE_BANNER = 'cart-maintenance-banner',
  CART_OLD_MAC_LINK = 'cart-old-mac-link',
  CART_LIMIT_DC_MULTI_YEAR_CONTRACTS = 'cart-limit-dc-multi-year-contracts',
}

export default FeatureFlags;
